import { storeAction, authAction } from "../actionTypes"
const initialState = {
    storeData:[],
    loader: false,
    autoAccept: false,
    selectedBranchId: localStorage.getItem("selectedBranchId") || null,
    selectedBranchName: localStorage.getItem("selectedBranchName") || null,
}

export default function store(state = initialState, {type, payload}) {
    switch(type) {
   
      case storeAction.STORE_DETAILS_INITIATE: {
        return {
          ...state, storeData: [],
          loader: true,
        }
      }
      case storeAction.STORE_DETAILS_SUCCESS: {
        return {
          ...state, 
          storeData:payload,
          autoAccept:payload?.data?.isAutoAccept,
          loader: false,
        }
      }
      case storeAction.STORE_DETAILS_FAILURE: {
        return {
          ...state, storeData: [],
          loader: false,
        }
      }

      case storeAction.SET_SELECTED_BRANCH: {
        return {
          ...state,
          selectedBranchId: payload.branchId,
          selectedBranchName: payload.branchName,
        }
      }

      case authAction.OWNER_LOGOUT_INITIATE:
      case authAction.OWNER_LOGOUT_SUCCESS: {
        return {
          ...state,
          selectedBranchId: null,
          selectedBranchName: null,
        }
      }
  
      default: 
      return state
  }
}